// extracted by mini-css-extract-plugin
export default {"errorStyling":"Cgm-errorStyling","cgmStyling":"Cgm-cgmStyling","embedStyling":"Cgm-embedStyling"};